var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ContentBaseService } from '../base/contentbase.service';
var TabService = /** @class */ (function (_super) {
    __extends(TabService, _super);
    function TabService(logger, api, router) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.router = router;
        _this.tabs = {};
        _this.tab = {};
        return _this;
    }
    TabService.prototype.resetTab = function () {
        this.tab = {};
        sessionStorage.removeItem('tab');
    };
    TabService.prototype.checkTab = function (url) {
        if (url === void 0) { url = this.router.url; }
        if (url.match(/\/list$|^\/member\/member_search$/)) {
            this.resetTab();
        }
    };
    TabService.prototype.setTab = function (groupName, index, url) {
        if (url === void 0) { url = this.router.url; }
        if (typeof this.tab[url] === 'undefined') {
            this.tab[url] = {};
        }
        this.tab[url][groupName] = index;
        sessionStorage.setItem('tab', JSON.stringify(this.tab));
    };
    TabService.prototype.getTab = function (groupName, components, url, paramTab) {
        if (url === void 0) { url = this.router.url; }
        if (Object.keys(this.tab).length === 0) {
            var tab = sessionStorage.getItem('tab');
            this.tab = {};
            if (tab) {
                this.tab = JSOG.parse(tab);
            }
        }
        var index = 0;
        if (typeof this.tab[url] !== 'undefined' && typeof this.tab[url][groupName] !== 'undefined') {
            index = this.tab[url][groupName];
        }
        else {
            var tabs = components.filter(function (x) { return x.component === 'TabComponent'; }).map(function (x) { return x.name; });
            var idx = tabs.indexOf(paramTab);
            index = idx >= 0 ? idx : 0;
        }
        this.setTab(groupName, index);
        return index;
    };
    TabService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TabService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: Router }
    ]; };
    return TabService;
}(ContentBaseService));
export { TabService };
//# sourceMappingURL=tab.service.js.map